const schema_resubmit = {
    postcode: {
        label: 'Postcode',
        placeholder: 'Postcode',
        type: "text",
        value: '',
        required: true,
    },
    vrm: {
        label: 'Vehicle Registration Number',
        placeholder: 'Vehicle Registration Number',
        type: 'text',
        value: '',
        required: true
    },
    telephone: {
        label: 'Telephone',
        placeholder: 'Telephone',
        type: 'text',
        value: '',
        required: true
    }
};
export default schema_resubmit;
